import { render, staticRenderFns } from "./GenitoriAdd.vue?vue&type=template&id=650df048"
import script from "./GenitoriAdd.vue?vue&type=script&lang=js"
export * from "./GenitoriAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports